import React from 'react';
export function Guarantee() {
  return <section className="py-8 md:py-12 px-4 bg-brand-dark border-t border-black/5" data-id="element-93">
      <div className="max-w-2xl mx-auto text-center" data-id="element-94">
        <h2 className="text-2xl md:text-3xl font-serif font-bold mb-6 text-brand-text" data-id="element-95">
          🛡️ GARANTÍA "FILOSOFÍA PRO" — 7 DÍAS
        </h2>

        <div className="bg-brand-card border border-black/10 rounded p-6 text-left space-y-4 text-sm md:text-base text-brand-text leading-relaxed" data-id="element-96">
          <p data-id="element-97">
            Abrís los 6 tomos. Revisás los 4 bonos. Usalos en tu clase más
            difícil este lunes.
          </p>
          <p data-id="element-98">
            Si el martes sentís que tus alumnos no participaron más, o que el
            material no tiene el rigor que buscabas:
          </p>
          <p className="font-bold text-lg text-brand-danger text-center py-2" data-id="element-99">
            Te devolvemos el 100%
          </p>
          <p className="text-center font-bold" data-id="element-100">
            Sin preguntas. Sin formularios. Sin dramas.
          </p>
          <p data-id="element-101">
            Queremos docentes satisfechos, no ventas por compromiso. Si el Kit
            no es lo que esperabas, escribinos. Una persona real te va a
            responder. No un bot. No un ticket automatizado. Una persona.
          </p>
          <p className="font-bold" data-id="element-102">
            Porque si el material no te sirve, no queremos tu dinero.
          </p>
        </div>

        <div className="mt-6 text-xs md:text-sm font-bold text-brand-text/80 flex flex-wrap justify-center gap-x-4 gap-y-2" data-id="element-103">
          <span data-id="element-104">🔒 Pago 100% seguro</span>
          <span data-id="element-105">📧 Entrega inmediata por email</span>
          <span data-id="element-106">💬 Soporte por WhatsApp</span>
        </div>
      </div>
    </section>;
}